import React from 'react';

import { FormattedMessage } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { Box, Text } from '@atlaskit/primitives/compiled';
import SectionMessage from '@atlaskit/section-message';
import { token } from '@atlaskit/tokens';

import { messages } from './messages';

const styles = cssMap({
	container: {
		paddingBlockEnd: token('space.075'),
		paddingInlineStart: token('space.100'),
		paddingInlineEnd: token('space.100'),
	},
});

export const AssetsDisplayNameBanner = (): React.JSX.Element => {
	return (
		<Box xcss={styles.container}>
			<SectionMessage appearance="information">
				<FormattedMessage
					{...messages.assetsDisplayNameSearchWarning}
					values={{ b: (chunks: React.ReactNode) => <Text weight="bold">{chunks}</Text> }}
				/>
			</SectionMessage>
		</Box>
	);
};
